import { render, staticRenderFns } from "./ElRealtimeChat.vue?vue&type=template&id=65cdfa9c"
import script from "./ElRealtimeChat.vue?vue&type=script&lang=js"
export * from "./ElRealtimeChat.vue?vue&type=script&lang=js"
import style0 from "./ElRealtimeChat.vue?vue&type=style&index=0&id=65cdfa9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports